import { TFunction } from 'i18next';

import { SearchUsersResponse } from 'src/types/rest/managementPortalApi';

interface GetUserInformationProps {
  t: TFunction;
  user: SearchUsersResponse;
}

/**
 * Previously we exposed first- and lastname, but this PII has been removed
 * when we migrated from IDM Proxy to MP BFF API for user search.
 *
 * We now display email or mobile and fallback to the user id as last resort.
 *
 * Email and mobile identifiers are optional. If email is present, it should be
 * displayed. If not, mobile should be displayed.
 */
export const getUserInformation = ({
  user,
}: GetUserInformationProps): string => {
  let identifier = user.id;

  if (user.mail) {
    identifier = user.mail;
  } else if (user.mobile) {
    identifier = user.mobile;
  }

  return identifier;
};
